export default "__VITE_ASSET__qoRltOB1__"